export default {
  managerFeedback: 'Manager',
  placeholder: 'Fügen Sie einen Kommentar hinzu...',
  noAttachments: 'Keine',
};
